

export interface AddressSegments {
  street: string;
  suburb: string;
  state: string;
  postcode: string
}
export const defaultAddressSegments: AddressSegments = {
  street: '',
  suburb: '',
  state: '',
  postcode: '',
};

export const addressJoin = (value: AddressSegments) => {
  return [
    value.street.trim(), 
    value.suburb.trim(), 
    value.state.trim(), 
    value.postcode.trim()
  ].filter(v => v.length > 0).join(' ');
}

const validateParseData = (data: any) => {
  if (typeof data.valid === "boolean"
   && typeof data.street === "string"
   && typeof data.suburb === "string"
   && typeof data.state === "string"
   && typeof data.postcode === "string") {
    return data;
  }
}



export const addressParse = async (value: string) => {
  const m = (new RegExp('^(https?\:\/\/[\\w\.]+\/apply/\\w+\/)(.*)$')).exec(document.URL);
  const url = m ?
    new URL(m[1] + 'blocks/details/parse-address/')
    :
    (
      document.URL.indexOf(':3000') === -1 ?
        null
        :
        new URL('https://vm.secure.polygongroup.com.au/apply/musicorp/blocks/details/parse-address/'
        )
    );
  if (url) {
    url.searchParams.append('address', value);
    const response = await fetch(url.href, {
      credentials: "include"
    });
    
    if (response.ok) {
      const contentType = response.headers.get('Content-Type');
      if (contentType === 'application/json') {
        const data = await response.json();
        if (data.success === false) {
          throw Error(data.message || 'Session expired');
        }
        if (data.success !== false && validateParseData(data)) {
          return data as AddressSegments & {valid: boolean};
        }
        throw Error(`Data not in the correct format`);
      }
      throw Error(`Excepted content type of "application/json" but received ${contentType}`);
    }
    throw Error(`Invalid response ${response.status}`);
  }
  else {
    throw Error(`Invalid document.URL`);
  }
};